import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormArray,
  FormBuilder,
  ValidatorFn,
  ValidationErrors,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { FormTemplateDataEntryService } from "./../services/form-template-data-entry.service";
import { IDataEntryForm, IInputField } from "./../models/data-entry.model";
import { ZpDataService } from "./../services/zp-data.service";
import { IUrlParameter } from "./../models/data-entry.model";
import { TextDictionaryService } from "./../services/text-dictionary.service";
import textList from "../../assets/data/text-dictionary.json";
import countries from "../../assets/data/countries.json";
import { NgbCalendar } from "@ng-bootstrap/ng-bootstrap";
import { DynamicHelpers } from "./../helpers/dynamic-helpers";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "../models/user.model";
import { Subscription } from "rxjs";
import { delay } from "rxjs/operators";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
// import { helpers } from "chart.js";
import { Location } from "@angular/common";
import { ThemeService } from "../theme/theme-service.service";
import { PreviousUrlService } from "../services/previous-url.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";

@Component({
    selector: "app-dynamic-edit",
    templateUrl: "./../dynamic-form-data-entry/dynamic-form-data-entry.component.html",
    styleUrls: [
        "./../dynamic-form-data-entry/dynamic-form-data-entry.component.scss",
    ],
    standalone: false
})
export class DynamicEditComponent implements OnInit, OnDestroy {
  public myFormGroup: FormGroup = new FormGroup({});
  public myFormTemplate: IDataEntryForm;
  public templateName;
  public Id;
  public false;
  public myItem = {};
  public sectionTitle = "";
  public showHelp = false;
  public submitted = false;
  public myTextList = textList;
  public myCountries = countries;
  public subscription: Subscription;
  public buttonText = "Save Changes";
  public myOptionItem;
  public otherFreeText = false;
  public message: string;
  public showList = false;
  public hideList: string[] = [];
  public yesNoToggleHideShowList: string[] = [];
  public statusTooltipMobile = [];
  public editMode = true;
  public dummyShowTrigger: boolean = false;
  public date: { year: number; month: number };
  public currentReview;
  public myUser: IUser;
  public itemName: string;
  public disabled;
  public dataIsLoaded: boolean = false;
  public breadCrumbText: any;
  public isIE = false;
  public categoryCounts: any;
  public mySharedPlans: {}[];
  public hasPlan;
  public id;
  public isDE = true;
  public myClient: any;
  public myClientSharedPlanUserId: any;
  public questionMarkMobile;
  public consentUser;
  public newItemId;
  public letterQuota;
  public opt;
  public selectedValue;
  public selectFixBool;
  public isCurrency: boolean;
  public currencyType: string;
  public jointOwnersList: any;
  public isOwnerListEmpty: boolean;
  public ownerList: any;
  public ownersList: any = [];
  public selectedOwnersList: any = [];
  public selectedOwners;
  public selectedOwner;
  public statusGetetingStarted;
  public errorMessage;
  public lastUpdate;
  public form;
  public sharedPlanCategories: any;
  public ownersHashmap: {} = {};
  public directInvoice: any;
  public mapping = {
    now: "viewer now",
    future: "viewer future",
  };
  public removeCheckmark: boolean;
  public previousLink: string;
  public companyDetails: {
    userType?: string;
    professionalLicense?: string;
    funded?: boolean;
    hideSponsor?: boolean;
    directInvoice?: boolean;
    email?: string;
    company?: string;
    logo?: string;
    firstName?: string;
    lastName?: string;
    professionalId?: string;
    nfz?: any
  };
  public textAreaModel;
  explanations = [
    {
      title: "How ownership works",
      image: "how-works.svg",
      status: false,
      description:
        "When you add a financial item to your plan, you can allocate it to one or more owners. There are three ownership options.",
      options: [
        {
          title: "Sole owner",
          content:
            "The item is wholly owned by one person e.g. you or your spouse. The full value of the item is assigned to the owner in the Financial Summaries.",
        },
        {
          title: "Joint tenant",
          content:
            "The owners jointly own the whole item - this is common for married couples. The full value of the item is assigned to both owners in the Financial Summaries.",
        },
        {
          title: "Tenants in common",
          content:
            "The owners each own a specified share of the item. The specified share of the item is assigned to each owner in the Financial Summaries.",
        },
      ],
    },
    {
      title: "About Delegates",
      image: "delegate.svg",
      status: false,
      description:
        "Flexible sharing options allow you to share what you wish, when you wish with those closest to you in life.",
      options: [
        {
          title: "Contributor",
          content:
            "Allows your delegate to view and edit your plan so that they can help you to build and manage it.",
        },
        {
          title: "Viewer: Now",
          content:
            "Allows your delegate to view your plan, without the ability to edit it by themselves.",
        },
        {
          title: "Viewer: Future",
          content:
            "Allows your delegate to view your plan only when you pass away or if you lose mental capacity.",
        },
        {
          title: "Never",
          content:
            "Prevents your delegate from accessing your plan at all times.",
        },
      ],
    },
  ];
  isNFZ: boolean;
  public statusExplanations: boolean;
  public form_elem;
  public nextItem;
  statusExplanationsLink: boolean;
  contributorArrays: any = [];
  allThePermissionsAreContributor: boolean = false;
  showConfirmationModal
  @ViewChild('mySelect', { static: false }) mySelect: ElementRef;
  previousValue: string;
  personToNotifyList: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ftService: FormTemplateDataEntryService,
    private dictService: TextDictionaryService,
    private ZpDataService: ZpDataService,
    private fb: FormBuilder,
    private calendar: NgbCalendar,
    private userInfoService: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService,
    private location: Location,
    private previousUrl: PreviousUrlService,
    private getInfoAndPassService: GetInfoAndPassService
  ) {
    this.isIE = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    this.activatedRoute.paramMap.subscribe((params) => {
      this.templateName = params.get("templateName");
      console.log("activatedRoute() - ", this.templateName);
      this.Id = params.get("Id");
    });
  }

  async ngOnInit() {
    this.previousLink = this.previousUrl.getPreviousUrl();
    console.log("previousLink: ", this.previousLink);
    if (this.router.url == "/dynamicedit/about-me-edit/" + this.Id) {
      this.sideNavBarVisibilityService.hideSideNav = true;
    }
    this.subscription = this.userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
      console.log('myUser: ', this.myUser);
      this.directInvoice =
        this.ZpDataService.getRefCodeInfo() &&
        this.ZpDataService.getRefCodeInfo().directInvoice;
      this.companyDetails = this.ZpDataService.getRefCodeInfo();
      console.log("companyDetails: ", this.companyDetails);
      if (this.companyDetails && this.companyDetails.nfz) {
        this.isNFZ = true;
      } else {
        this.isNFZ = false;
      }
      // JDM: We're checking if professionalId property has the same as companyDetails.professionalId to declare a globalVariable
      // that we can use in dynamicFormDataEntry HTML to change the subject title of the professional only.

      // Check if myUser has 'professionalId' property and compare its value
      if (
        this.myUser &&
        this.myUser.professionalId &&
        this.myUser.professionalId === this.companyDetails.professionalId
      ) {
        console.log("professionalId values match");
      } else {
        console.log(
          "professionalId values do not match or property is missing"
        );
      }
    });
    this.dataIsLoaded = false;
    let counter = 0;
    while (!this.myUser) {
      counter++;
      if (counter > 10000) {
        break;
      }
    }
    if (this.companyDetails && this.isNFZ) {
      this.myFormTemplate = await this.ftService.getFormTemplateAsyncForNFZ(
        this.templateName,
        this.companyDetails.professionalLicense
      );
    } else {
      this.myFormTemplate = await this.ftService.getFormTemplateAsync(
        this.templateName
      );
    }
    console.log("myFormTemplate - ", this.myFormTemplate);
    if (this.myFormTemplate.url == "delegates") {
      this.statusExplanationsLink = true;
    }
    // this.myFormTemplate = await this.ftService.getFormTemplateAsync(
    //   this.templateName
    // );
    // let clientId = (this.myUser) ? (this.myUser.sharedPlanUserId ? this.myUser.sharedPlanUserId : this.myUser.Id) : undefined;
    let clientId = this.myUser.sharedPlanUserId
      ? this.myUser.sharedPlanUserId
      : this.myUser.Id;
    console.log('clientId: ', clientId);
    this.myItem = await this.ZpDataService.getItem(
      this.Id,
      this.myFormTemplate.sectionTitle,
      clientId
    );
    await this.getFields();
    this.dataIsLoaded = true;
    this.myClient = this.myUser.sharedPlanUserId
      ? this.myUser.sharedPlanUserId
      : this.myUser;
    this.myClientSharedPlanUserId = this.myUser.sharedPlanUserId;

    if (this.myUser.sharedPlanUserId) {
      this.sharedPlanCategories = await this.ZpDataService.getPlan(
        this.myUser.sharedPlanUserId
      );
      console.log('myUser.sharedPlanUserId: ', this.myUser.sharedPlanUserId);
      console.log("sharedPlanCategories - 2", this.sharedPlanCategories);
      if (this.sharedPlanCategories) {
        for (let itemType in this.sharedPlanCategories) {
          for (let item of this.sharedPlanCategories[itemType]) {
            console.log("item! -", item);
            if (item.newJointOwners) {
              for (let owner of item.newJointOwners) {
                console.log("owner - ", owner);
                this.ownersHashmap[owner.owner.first + owner.owner.last] =
                  owner.owner;
                // console.log('this.ownersSelectedHashmap - ', this.ownersSelectedHashmap)
                // this.test.push(this.ownersSelectedHashmap)
              }
            }
          }
        }
        this.selectedOwners = this.ZpDataService.displaySharedPlansOwner(
          Object.values(this.ownersHashmap)
        );
        console.log("selectedOwners 1 - ", this.selectedOwners);
      }
    } else {
      this.selectedOwners = this.myUser.jointOwners;
      console.log("selectedOwners 2 - ", this.selectedOwners);
    }
  }

  isOwnedBy(owner) {
    let o: any;
    console.log((o = this.ownersList[0]));
    console.log(
      "isownedby: ",
      owner.first == o.owner.first && owner.last == o.owner.last
    );
    if (owner.first == o.owner.first && owner.last == o.owner.last) {
      return true;
    }
    return false;
  }
  async getFields() {
    //adding fields to group for sending to save
    this.sectionTitle = this.myFormTemplate.sectionTitle; //await this.getText(this.myFormTemplate.sectionTitle);
    if (this.myItem["itemName"]) {
      this.itemName = this.myItem["itemName"];
    }

    if (this.myItem["firstName"]) {
      this.itemName = this.myItem["firstName"] + " " + this.myItem["lastName"];
    }
    //adding controls that will not be in the interface but will save existing
    //data when we save the form group value.
    let clientId = this.myUser.sharedPlanUserId
      ? this.myUser.sharedPlanUserId
      : this.myUser.Id;
    this.myFormGroup.addControl("clientId", new FormControl(clientId));
    this.myFormGroup.addControl("Id", new FormControl(this.Id));
    if (this.sectionTitle == "delegates") {
      this.myFormGroup.addControl(
        "delegateId",
        new FormControl(this.myItem["delegateId"])
      );
    }
    if (this.sectionTitle == "users") {
      this.myFormGroup.addControl(
        "sectionList",
        new FormControl(this.myItem["sectionList"])
      );
    }
    this.myFormGroup.addControl('lookupPersonToNitify', new FormControl(''));
    var objectKeys = Object.keys(this.myItem);
    var objectValues = Object.values(this.myItem);
    var sonIndex = objectKeys.findIndex(
      (jj) => jj.toLowerCase() === "uptodateexpire"
    );
    let myVal = objectValues[sonIndex] as string;
    var myValue;
    for (let i = 0; i < this.myFormTemplate.fields.length; i++) {
      //this.myFormTemplate.fields.forEach(async templateObject => {
      myValue = "";
      // var mySonList;
      var index = objectKeys.findIndex(
        (ff) =>
          ff.toLowerCase() ==
          this.myFormTemplate.fields[i].fieldid.toLowerCase()
      );
      var fieldValue = objectValues[index] as string;
      if (fieldValue) {
        myValue = fieldValue;
        console.log("dynamicEdit, myValue: ", myValue);
      }
      if (myValue == "contributor") {
        this.contributorArrays.push(myValue);
      }
      console.log("contributorArrays: ", this.contributorArrays);
      if (this.contributorArrays.length === 5 && this.contributorArrays.every(value => value === 'contributor')) {
        console.log("The array has a length of 5 and all values are 'contributor'.");
        this.allThePermissionsAreContributor = true;
      } else {
        console.log("The array does not meet the criteria.");
      }

      if (this.myFormTemplate.fields[i].inputtype == "radiobuttons") {
        //finding the saved value of the radio button
        if (this.myFormTemplate.fields[i].urlparameters) {
          this.myFormTemplate.fields[i].urlparameters.forEach((up) => {
            var sonIndex = objectKeys.findIndex(
              (jj) =>
                jj.toLowerCase() ===
                this.myFormTemplate.fields[i].fieldid.toLowerCase()
            );
            let myVal = objectValues[sonIndex] as string;
            if (myVal && myVal.length > 0) {
              myValue = myVal;
            }
          });
        }
      }
      //If a option for show other fields in the show fields list, don't add those fields to the hideList.
      //Only if the saved option has an action of "hide"
      if (this.myFormTemplate.fields[i].showFields) {
        if (this.myFormTemplate.fields[i].inputtype == "radiobuttonsshow") {
          this.myFormTemplate.fields[i].options.forEach((option) => {
            if (option["option"] == myValue && option["action"] == "hide") {
              this.myFormTemplate.fields[i].showFields.map((field) => {
                this.hideList.push(field);
              });
            }
          });
        } else {
          this.myFormTemplate.fields[i].showFields.map((field) => {
            this.hideList.push(field);
          });
        }
      }
      if (
        this.myFormTemplate.fields[i].inputtype.includes(
          "conditionaldropdown"
        ) ||
        this.myFormTemplate.fields[i].inputtype == "yesnotogglehideshow"
      ) {
        //adding urls in urlparamters that are fields to the hidelist so they won't show up on init
        this.myFormTemplate.fields[i].urlparameters.forEach((element) => {
          if (element.urlArray) {
            element.urlArray.forEach((url) => {
              if (url.length > 0) {
                this.hideList.push(url);
                if (
                  this.myFormTemplate.fields[i].inputtype ==
                  "yesnotogglehideshow"
                ) {
                  this.yesNoToggleHideShowList.push(url);
                }
              }
            });
          }
        });
      }
      if (!this.myFormTemplate.fields[i].inputtype.includes("formarray")) {
        if (this.myFormTemplate.fields[i].validators) {
          var myValidators: ValidatorFn[] = [];
          var validators: [{}] = this.myFormTemplate.fields[i].validators;
          this.myFormTemplate.fields[i].validators.map((validator) => {
            switch (validator["type"]) {
              case "max":
                myValidators.push(Validators.max(validator["value"]));
                break;
              case "min":
                myValidators.push(Validators.min(validator["value"]));
                break;
              case "maxLength":
                myValidators.push(Validators.maxLength(validator["value"]));
                break;
              case "minLength":
                myValidators.push(Validators.minLength(validator["value"]));
                break;
              case "required":
                myValidators.push(Validators.required);
                break;
              case "email":
                myValidators.push(Validators.email);
                break;
            }
          });
          if (
            this.myFormTemplate.fields[i].mandatory &&
            !myValidators.includes(Validators.required)
          ) {
            myValidators.push(Validators.required);
          }
          if (this.myFormTemplate.fields[i].inputtype.includes("number")) {
            this.myFormGroup.addControl(
              this.myFormTemplate.fields[i].fieldid,
              new FormControl(myValue, Validators.compose(myValidators))
            );
          } else {
            if (
              this.myFormTemplate.fields[i].inputtype.includes("multiselect")
            ) {
              this.myFormGroup.addControl(
                this.myFormTemplate.fields[i].fieldid,
                new FormControl([])
              );
            } else {
              await this.myFormGroup.addControl(
                this.myFormTemplate.fields[i].fieldid,
                new FormControl(myValue, Validators.compose(myValidators))
              );
            }
          }
        }
      }

      switch (this.myFormTemplate.fields[i].inputtype) {
        case "jointOwnersList": {
          this.isOwnerListEmpty = false;
          if (myValue) {
            console.log("jointOwnersList myValue - ", myValue);
            this.ownersList = myValue.map((owner) => {
              owner.Checked = true;
              return owner;
            });
            this.selectedOwnersList = [];
            this.ownersList.forEach((o) => {
              console.log("o - ", o);
              this.selectedOwnersList[o.owner.first + o.owner.last] = true;
            });
          }
        }

        default: {
          this.myFormGroup.addControl(
            this.myFormTemplate.fields[i].fieldid,
            new FormControl(myValue)
          );
          break;
        }
      }

      switch (this.myFormTemplate.fields[i].inputtype) {
        case "personToNotifyForDigitalLegacy": {
          if (myValue) {
            console.log("Raw myValue - ", myValue);
      
            // Convert array of strings from server to array of objects
            this.personToNotifyList = myValue.map((entry: string) => {
              const [name, email, dataShared] = entry.split(" | ");
              return { name, email, dataShared };
            });
      
            console.log("Transformed personToNotifyList - ", this.personToNotifyList);
          } else {
            this.personToNotifyList = [{ name: '', email: '', dataShared: 'All' }];
          }
          break;
        }
      
        default: {
          this.myFormGroup.addControl(
            this.myFormTemplate.fields[i].fieldid,
            new FormControl(myValue)
          );
          break;
        }
      }
      
      
      
      
      
      //}
      let clientId = this.myUser.sharedPlanUserId
        ? this.myUser.sharedPlanUserId
        : this.myUser.Id;
      // let clientId = this.myUser ? (this.myUser.sharedPlanUserId ? this.myUser.sharedPlanUserId : this.myUser.Id) : undefined;
      if (this.myFormTemplate.fields[i].listSource) {
        this.myFormTemplate.fields[i].items =
          await this.ZpDataService.getSectionItemNames(
            this.myFormTemplate.fields[i].listSource,
            clientId,
            this.myFormTemplate.fields[i].itemType
          );
      }
      if (
        this.myFormTemplate.fields[i].inputtype == "dropdownshowmultiselect" ||
        this.myFormTemplate.fields[i].inputtype ==
          "dropdownshowmultiselectid" ||
        this.myFormTemplate.fields[i].inputtype == "dropdownid"
      ) {
        //Get the dropdownlist
        this.myFormTemplate.fields[i].itemArray =
          await this.ZpDataService.getSectionItemIdsAndNames(
            this.myFormTemplate.fields[i].listSource,
            clientId,
            this.myFormTemplate.fields[i].itemType
          );
        // if (this.myFormTemplate.fields[i].inputtype == "dropdownid") {
        //   if (this.myFormTemplate.fields[i].fieldid == "itemName") {
        //     //this.myFormGroup.addControl("itemNameText", new FormControl(''));
        //   }
        // }
      }
    }
    //fire forkclick now that we have all the fields in place
    //as a baseline, we set all sons of yesNoToggleHideShow fields
    //to disabled, and will enable only those that will be visible.
    this.yesNoToggleHideShowList.map((field) => {
      if (this.myFormGroup.controls[field]) {
        this.myFormGroup.controls[field].disable();
      }
    });
    var myValue2;
    //scanning all fields for radiobuttons and yesnotogglehideshow
    for (let i = 0; i < this.myFormTemplate.fields.length; i++) {
      //var kuku = this.myFormTemplate.fields.forEach(async templateObject => {
      if (
        this.myFormTemplate.fields[i].inputtype == "radiobuttons" || //"radiobuttons" don't seem to be in use in any edit json
        this.myFormTemplate.fields[i].inputtype == "yesnotogglehideshow"
      ) {
        //myValue = "";
        //urlparamters are the fields to hide or show
        if (this.myFormTemplate.fields[i].urlparameters) {
          this.myFormTemplate.fields[i].urlparameters.forEach((up) => {
            var sonIndex = objectKeys.findIndex(
              (jj) =>
                jj.toLowerCase() ===
                this.myFormTemplate.fields[i].fieldid.toLowerCase()
            );
            let myVal = objectValues[sonIndex] as string;
            //myVal is the current value of each radiobutton or yesnotogglehideshow
            if (
              myVal &&
              (this.myFormTemplate.fields[i].inputtype == "radiobuttons"
                ? myVal.length > 0
                : true)
            ) {
              myValue2 = myVal;
            }
          });
          //we are only dealing here with yes/no scenario
          if (
            this.myFormTemplate.fields[i].urlparameters[0]["option"] == "Yes"
          ) {
            //a yes/no component
            if (this.myFormTemplate.fields[i].inputtype == "radiobuttons") {
              this.forkClickYesNo(
                this.myFormTemplate.fields[i].fieldid,
                this.myFormTemplate.fields[i].urlparameters,
                true
              );
            } else {
              //yes no toogle hide show
              //the main function to do the work to set up the sons of  yesnotogglehideshow
              if (
                !this.hideList.includes(this.myFormTemplate.fields[i].fieldid)
              ) {
                //it has already been hidden in the recursion
                await this.forkClickYesNoHideShow(
                  this.myFormTemplate.fields[i].fieldid,
                  this.myFormTemplate.fields[i].urlparameters,
                  false,
                  true
                );
              }
            }
          } else {
            //radiobuttons with texts
            this.myFormTemplate.fields[i].urlparameters.forEach((param) => {
              if (param.option == myValue2) {
                this.forkClick(
                  param,
                  this.myFormTemplate.fields[i].urlparameters
                );
              }
            });
          }
        }
      }
      if (
        this.myFormTemplate.fields[i].inputtype.includes("conditionaldropdown")
      ) {
        let localValue = await this.myFormGroup.controls[
          this.myFormTemplate.fields[i].fieldid
        ].value;
        if (localValue) {
          console.log("localValue - ", localValue);
          //we need to give the form a kick in order to trigger the hidding/showing of the correct objects
          this.changeSelection(
            null,
            this.myFormTemplate.fields[i].urlparameters,
            localValue
          );
        }
      }
    }
    if (this.myFormTemplate.editInSteps) {
      this.buttonText = "Next";
    }
    if (this.myFormTemplate.Submit) {
      this.buttonText = "Submit";
      if (this.myFormTemplate.Submit && this.myFormTemplate.aboutMe == true)
        this.buttonText = "Continue";
    }
    this.dummyShowTrigger = true;
    //disable fields that are not shown to prevent validation problems
    this.hideList.map((hiddenField) => {
      if (this.myFormGroup.controls[hiddenField]) {
        this.myFormGroup.controls[hiddenField].disable();
      }
    });
  }


  onPersonChange(index?: number, field?: string, value?: string) {
    this.personToNotifyList[index][field] = value.trim();
  
    this.emitPersonData();
  }
  
  addPerson() {
    this.personToNotifyList.push({ name: '', email: '', dataShared: 'All' });
    this.emitPersonData();
  }
  
  removePerson(index: number) {
    this.personToNotifyList.splice(index, 1);
    this.emitPersonData();
  }
  
  private emitPersonData() {
    const updatedValue = this.personToNotifyList.map(person => 
      `${person.name} | ${person.email} | ${person.dataShared}`
    );
  
    if (this.myFormGroup.controls['personToNotifyForDigitalLegacy']) {
      this.myFormGroup.controls['personToNotifyForDigitalLegacy'].setValue(updatedValue);
      console.log("Updated personToNotifyForDigitalLegacy - ", this.myFormGroup.controls['personToNotifyForDigitalLegacy'].value);
    } else {
      console.warn("personToNotifyForDigitalLegacy does not exist in the form group.");
    }
  }
  
 
  
  
  

  
  handleSaveClick() {
    this.checkPermissionsModal();
    if (this.allThePermissionsAreContributor) {
      this.showConfirmationModal = true;
    }
    else {
      this.goto('saveDelegatePermissions'); 
    }
  }

  confirmSave() {
    this.showConfirmationModal = false;
    this.onSubmit();
    this.goto();
  }

  cancelSave() {
    this.showConfirmationModal = false;
  }

  closeExplanationAboutDelegates(event) {
    // console.log("close explanations + event: ", event);
    if (event) {
      this.statusExplanationsLink = false;
    }
  }

  createNewOwner() {
    this.router.navigate(["/account-settings/itemOwners"]);
  }

  getCheckboxValues(ev, data, fieldId) {
    const ownerObj = {
      owner: data,
    };
    console.log('getCheckboxValues(), ownerObj - ', ownerObj);
    console.log('getCheckboxValues(), data - ', data);
    console.log('getCheckboxValues(), ownersList - ', this.ownersList);
    if (ev.target.checked) {
      console.log('getCheckboxValues() - has been checked');
      this.ownersList.push(ownerObj);
    } else {
      if (data) {
        // this.ownersList.splice(this.ownersList.indexOf(data), 1);
        // this.ownersList = this.ownersList.filter(item => item.owner.first !== data.first && item.owner.last !== data.last);
        this.ownersList = this.ownersList.filter(item => item.owner.first !== data.first || item.owner.last !== data.last);

        console.log('getCheckboxValues() - has been unchecked ', this.ownersList);
      }
    }
    if (this.ownersList.length === 0) {
      console.log("getCheckboxValues(), ownersList is empty");
      this.isOwnerListEmpty = true;
    } else {
      console.log("getCheckboxValues(), ownersList is not empty");
      this.isOwnerListEmpty = false;
    }
    this.addOwnershipFormValue({
      fieldId: fieldId,
      newJointOwnershipToSend: this.ownersList,
    });
    console.log('getCheckboxValues(), last step - ', this.ownersList);
}


  addOwnershipFormValue(ownerListSelected) {
    console.log("ownerListSelected -> ", ownerListSelected);
    if (!ownerListSelected.error) {
      this.myFormGroup.controls[ownerListSelected.fieldId].setValue(
        ownerListSelected.newJointOwnershipToSend
      );
      console.log(
        "addOwnershipFormValue(), myFormGroup values - ",
        this.myFormGroup.value
      );
    } else {
      this.goto(ownerListSelected.error);
    }
    console.log(this.myFormGroup.controls);
  }

  async onSubmit() {
    this.dummyShowTrigger = false;
    this.sideNavBarVisibilityService.changeMessage("bottom");
    if (this.myFormGroup.invalid) {
      this.submitted = true;
      return;
    }
    if (this.myFormTemplate.finished || !this.myFormTemplate.editInSteps) {
      this.myFormGroup.value["lastUpdate"] = new Date();
      let changedBy = this.myUser.Id; //either the delegate or the clinet - depending on who is logged in now.
      this.myFormGroup.value["lastUpdateBy"] = changedBy;
      if (this.myFormTemplate.itemNameFields) {
        var myItemName = "";
        this.myFormTemplate.itemNameFields.map((field) => {
          this.myOptionItem += this.myFormGroup.value[field] + " ";
        });
        this.myFormGroup.value["itemName"] = myItemName;
      }
      if (this.myFormTemplate.sectionTitle == "general expenses") {
        this.myFormGroup.value["itemName"] = "General Expenses";
      }
      // if (this.myFormTemplate.sectionTitle == "will") {
      //   this.myFormGroup.value["itemName"] = "Will";
      // }

      //need to clear any values of components that were hidden
      DynamicHelpers.clearHiddenFieldValues(
        this.myFormTemplate,
        this.myFormGroup
      );
      //log changes
      await this.ZpDataService.logChanges(
        this.myFormGroup.value,
        this.sectionTitle,
        changedBy
      );
      //test
      let pp = JSON.stringify(this.myFormGroup.value);
      let success = false;
      if (this.myUser.sharedPlanUserId) {
        success = await this.ZpDataService.updateItem(
          pp,
          this.myFormTemplate.sectionTitle,
          this.myUser.sharedPlanUserId
        );
      } else {
        success = await this.ZpDataService.updateItem(
          pp,
          this.myFormTemplate.sectionTitle
        );
      }
      //following are a bunch of triggers for handling the sync between properties and UMI
      if (success) {
        let myUserId = this.myUser.sharedPlanUserId
          ? this.myUser.sharedPlanUserId
          : this.myUser.Id;
        if (this.myFormTemplate.sectionTitle == "insurance") {
          if (
            (!this.myFormGroup.value["propertyId"] &&
              this.myItem["propertyId"]) ||
            (this.myItem["propertyId"] &&
              this.myFormGroup.value["propertyId"] != this.myItem["propertyId"])
          ) {
            await this.ZpDataService.removeInsuranceFromProperty(
              this.myFormGroup.value["Id"],
              this.myItem["propertyId"],
              myUserId
            );
          }
          if (this.myFormGroup.value["propertyId"]) {
            await this.ZpDataService.addInsuranceToProperty(
              this.myFormGroup.value["Id"],
              this.myFormGroup.value["propertyId"],
              myUserId
            );
          }
        }
        if (this.myFormTemplate.sectionTitle == "mortgages") {
          if (
            (!this.myFormGroup.value["propertyId"] &&
              this.myItem["propertyId"]) ||
            (this.myItem["propertyId"] &&
              this.myFormGroup.value["propertyId"] != this.myItem["propertyId"])
          ) {
            await this.ZpDataService.removeMortgageFromProperty(
              this.myFormGroup.value["Id"],
              this.myItem["propertyId"],
              myUserId
            );
          }
          if (this.myFormGroup.value["propertyId"]) {
            await this.ZpDataService.addMortgageToProperty(
              this.myFormGroup.value["Id"],
              this.myFormGroup.value["propertyId"],
              myUserId
            );
          }
        }
        if (this.myFormTemplate.sectionTitle == "utilities") {
          if (
            (!this.myFormGroup.value["propertyId"] &&
              this.myItem["propertyId"]) ||
            (this.myItem["propertyId"] &&
              this.myFormGroup.value["propertyId"] != this.myItem["propertyId"])
          ) {
            await this.ZpDataService.removeUtilityFromProperty(
              this.myFormGroup.value["Id"],
              this.myItem["propertyId"],
              myUserId
            );
          }
          if (this.myFormGroup.value["propertyId"]) {
            await this.ZpDataService.addUtilityToProperty(
              this.myFormGroup.value["Id"],
              this.myFormGroup.value["propertyId"],
              myUserId
            );
          }
        }
        if (this.myFormTemplate.sectionTitle == "property") {
          //will update the UMI property field with the current user choices
          await this.ZpDataService.addPropertyToUtilitiesMortgagesInsurance(
            this.myFormGroup.value,
            myUserId
          );
        }
      }
      this.submitted = true;
    }
    if (this.myFormTemplate.editInSteps) {
      this.submitted = false;
      this.goto(this.myFormTemplate.url + "/" + this.myFormGroup.value["Id"]);
    } else {
      this.goto(this.myFormTemplate.url);
    }
  }
  public getPreviousCurrencyValue(fieldId) {
    // console.log("this.myFormGroup.controls[fieldId].value",this.myFormGroup.controls[fieldId].value)
    return this.myFormGroup.controls[fieldId].value;
  }

  getCurrencyValue(currencyValueSelected) {
    console.log(currencyValueSelected);
    this.myFormGroup.controls[currencyValueSelected.fieldId].setValue(
      currencyValueSelected.currencyValueToSend
    );
    console.log(this.myFormGroup.controls);
  }

  setRadioButton() {}

  forkClick(item, elements) {
    //Note: to hide/show the fields we would need to use showMe and add remove fields from this.hideList
    elements.forEach((element) => {
      if (element.url[0]) {
        element.url.forEach((element2) => {
          if ((item.url as [""]).includes(element2)) {
            if (this.myFormGroup.controls[element2]) {
              this.myFormGroup.controls[element2].enable();
              this.manageHideFields("show", [element2]);
            }
          } else {
            if (this.myFormGroup.controls[element2]) {
              this.myFormGroup.controls[element2].disable();
              this.manageHideFields("hide", [element2]);
            }
            // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
          }
        });
      } //simple enable or disable one field per radio click
      else {
        if (element.url == item.url) {
          this.myFormGroup.controls[element.url].enable();
        } else {
          this.myFormGroup.controls[element.url].disable();
          // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
        }
      }
    });
  }

  forkClickYesNoHideShow(fieldId, urlparameters, disabled, init?) {
    //All the sons of the yes no toggle are already disabled.
    //We need to enable the sons of the option which is is the data - sons of Yes or No
    //If one of the sons is another yes no toggle hide show - recursion.
    //Note: init == true on init - first fill. During run time the values are the opposite - onclick still sees the previous value
    //but probably for the first value only - the recursion calls will be like init. Complicated!
    var myElements: [] = urlparameters;
    let myElementYes = myElements.find((element) => element["option"] == "Yes");
    let myElementNo = myElements.find((element) => element["option"] == "No");
    var myInit = false;
    if (init) {
      myInit = true;
    }
    //what is the value of the yes no?
    //if(the yes no is enabled){
    //if(true and enabled){yes
    //scan the sons of yes and enable and show them
    //if a son is toggle yes no show - recurse it to show and enable value sons
    //scan the sons of no and disable and hide them
    //if a son is toggle yes no show - recurse it to hide and disable the sons
    // } else the opposite
    //}
    //else{ the yes no is disabled - disable all the sons of

    //}

    if (disabled) {
      //all sons need to be disabled and hidden
      let myUrlsYes = myElementYes["urlArray"] as Array<string>;
      for (let i = 0; i < myUrlsYes.length; i++) {
        //(myElementYes["urlArray"] as Array<string>).forEach(url => { //hide all generations of this disabled yes no toggle
        if (this.myFormGroup.controls[myUrlsYes[i]]) {
          this.myFormGroup.controls[myUrlsYes[i]].disable();
          this.manageHideFields("hide", [myUrlsYes[i]]);
          if (
            this.getTemplateInputtype(myUrlsYes[i]) == "yesnotogglehideshow"
          ) {
            let myTemplate = this.getTemplateField(myUrlsYes[i]);
            this.forkClickYesNoHideShow(
              myUrlsYes[i],
              myTemplate.urlparameters,
              true,
              myInit
            );
          }
        }
      }
      let myUrlsNo = myElementNo["urlArray"] as Array<string>;
      for (let i = 0; i < myUrlsNo.length; i++) {
        //(myElementNo["urlArray"] as Array<string>).forEach(url => {
        if (this.myFormGroup.controls[myUrlsNo[i]]) {
          this.myFormGroup.controls[myUrlsNo[i]].disable();
          this.manageHideFields("hide", [myUrlsNo[i]]);
          //if the field disable is a yenotogglehideshow - then disable all of its children
          if (this.getTemplateInputtype(myUrlsNo[i]) == "yesnotogglehideshow") {
            let myTemplate = this.getTemplateField(myUrlsNo[i]);
            this.forkClickYesNoHideShow(
              myUrlsNo[i],
              myTemplate.urlparameters,
              true,
              myInit
            );
          }
        }
      }
      return;
    }
    //not disabled: show and hide according to choice
    //enable the fields
    //if (this.myFormGroup.controls[fieldId].value || true) {
    if (
      myInit
        ? this.myFormGroup.controls[fieldId].value
        : !this.myFormGroup.controls[fieldId].value
    ) {
      //Yes - we need to show the sons of yes and hide sons of no
      //(and to recurse into sons that also  yesnotogglehideshow)
      let myUrlsYes = myElementYes["urlArray"] as Array<string>;
      for (let i = 0; i < myUrlsYes.length; i++) {
        if (this.myFormGroup.controls[myUrlsYes[i]]) {
          this.myFormGroup.controls[myUrlsYes[i]].enable();
          this.manageHideFields("show", [myUrlsYes[i]]);
          if (
            this.getTemplateInputtype(myUrlsYes[i]) == "yesnotogglehideshow"
          ) {
            let myTemplate = this.getTemplateField(myUrlsYes[i]);
            this.forkClickYesNoHideShow(
              myUrlsYes[i],
              myTemplate.urlparameters,
              false,
              true
            );
          }
        }
      }
      let myUrlsNo = myElementNo["urlArray"] as Array<string>;
      for (let i = 0; i < myUrlsNo.length; i++) {
        if (this.myFormGroup.controls[myUrlsNo[i]]) {
          this.myFormGroup.controls[myUrlsNo[i]].disable();
          this.manageHideFields("hide", [myUrlsNo[i]]);
          //if the field disable is a yenotogglehideshow - then disable all of its children

          if (this.getTemplateInputtype(myUrlsNo[i]) == "yesnotogglehideshow") {
            let myTemplate = this.getTemplateField(myUrlsNo[i]);
            this.forkClickYesNoHideShow(
              myUrlsNo[i],
              myTemplate.urlparameters,
              true,
              true
            );
          }
        }
      }
    } //No
    else {
      //disable the all yes fields
      let myUrlsYes = myElementYes["urlArray"] as Array<string>;
      for (let i = 0; i < myUrlsYes.length; i++) {
        if (this.myFormGroup.controls[myUrlsYes[i]]) {
          this.myFormGroup.controls[myUrlsYes[i]].disable();
          this.manageHideFields("hide", [myUrlsYes[i]]);
          if (
            this.getTemplateInputtype(myUrlsYes[i]) == "yesnotogglehideshow"
          ) {
            let myTemplate = this.getTemplateField(myUrlsYes[i]);
            this.forkClickYesNoHideShow(
              myUrlsYes[i],
              myTemplate.urlparameters,
              true,
              true
            );
          }
        }
      }
      //show the "no" fields
      let myUrlsNo = myElementNo["urlArray"] as Array<string>;
      for (let i = 0; i < myUrlsNo.length; i++) {
        if (this.myFormGroup.controls[myUrlsNo[i]]) {
          this.manageHideFields("show", [myUrlsNo[i]]);
          this.myFormGroup.controls[myUrlsNo[i]].enable();
          if (this.getTemplateInputtype(myUrlsNo[i]) == "yesnotogglehideshow") {
            let myTemplate = this.getTemplateField(myUrlsNo[i]);
            this.forkClickYesNoHideShow(
              myUrlsNo[i],
              myTemplate.urlparameters,
              false,
              true
            );
          }
        }
      }
    }
    //}
  }

  getTemplateInputtype(fieldId) {
    let myTemplate = this.getTemplateField(fieldId);
    return myTemplate.inputtype;
  }

  getTemplateField(fieldId) {
    let myTemplate: IInputField = this.myFormTemplate.fields.find(
      (field) => field.fieldid == fieldId
    );
    return myTemplate;
  }
  forkClickYesNo(fieldId, urlparameters, init?) {
    var myElements: [] = urlparameters;
    let myElementYes = myElements.find((element) => element["option"] == "Yes");
    let myElementNo = myElements.find((element) => element["option"] == "No");
    var myInit = false;
    if (init) {
      myInit = true;
    }
    //enable the fields
    if (
      myInit
        ? this.myFormGroup.controls[fieldId].value
        : !this.myFormGroup.controls[fieldId].value
    ) {
      //Yes
      if (myElementYes["url"][0]) {
        //it is a array of fields
        (myElementYes["url"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].enable();
            this.manageHideFields("show", [url]);
          }
        });
        (myElementNo["url"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].disable();
            this.manageHideFields("hide", [url]);
          }
        });
      } else {
        //one component without a array
        if (this.myFormGroup.controls[myElementYes["url"]]) {
          this.myFormGroup.controls[myElementYes["url"]].enable();
          this.manageHideFields("show", [myElementYes["url"]]);
        }
        if (this.myFormGroup.controls[myElementNo["url"]]) {
          this.myFormGroup.controls[myElementNo["url"]].disable();
          this.manageHideFields("hide", [myElementNo["url"]]);
        }
      }
    } //No
    else {
      //disable the fields
      if (myElementYes["url"][0]) {
        //it is a array of fields
        (myElementYes["url"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].disable();
            this.manageHideFields("hide", [url]);
          }
        });

        (myElementNo["url"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].enable();
            this.manageHideFields("show", [url]);
          }
        });
      } else {
        //one component without a array
        if (this.myFormGroup.controls[myElementYes["url"]]) {
          this.myFormGroup.controls[myElementYes["url"]].disable();
          this.manageHideFields("hide", [myElementYes["url"]]);
        }
        if (this.myFormGroup.controls[myElementNo["url"]]) {
          this.myFormGroup.controls[myElementNo["url"]].enable();
          this.manageHideFields("show", [myElementNo["url"]]);
        }
      }
    }
  }

  toggleYesNoLabel(fieldId) {
    if (this.myFormGroup.controls[fieldId].value) {
      document.getElementById("lbl_" + fieldId).innerHTML = "No";
    } else {
      document.getElementById("lbl_" + fieldId).innerHTML = "Yes";
    }
  }

  showHide(choice, showList) {
    if (choice == "Yes") {
      this.showList = true;
    } else {
      this.showList = false;
    }
  }
  showMe(fieldName) {
    if (!this.hideList) {
      return true;
    }
    if (this.hideList.length == 0) {
      return true;
    }
    if (this.hideList.includes(fieldName)) {
      return false;
    } else {
      return true;
    }
  }

  manageHideFields(choice, showList: string[]) {
    if (choice == "show") {
      showList.map((kk) => {
        this.myFormGroup.controls[kk].enable();
        if (this.hideList.includes(kk)) {
          let index = this.hideList.indexOf(kk);
          this.hideList.splice(index, 1);
        }
      });
    } else {
      showList.map((kk) => {
        this.myFormGroup.controls[kk].disable();
        if (!this.hideList.includes(kk)) {
          this.hideList.push(kk);
        }
      });
    }
    this.dummyShowTrigger = true;
  }

  // setSonsOfYesNoToggleHideShow(fieldId) {
  //   //get Template
  //   let myTemplate = this.getTemplateField(fieldId);
  //   var myElements = myTemplate.urlparameters;
  //   let myElementYes = myElements.find(element => element["option"] == "Yes");
  //   let myElementNo = myElements.find(element => element["option"] == "No");

  //   myElementYes.urlArray.forEach(url => {
  //     this.myFormGroup.controls[url].disable();
  //     this.manageHideFields("hide", [url]);
  //     if (this.getTemplateInputtype(url) == "yesnotogglehideshow") {
  //       this.setSonsOfYesNoToggleHideShow(url)
  //     }
  //   });
  //   myElementNo.urlArray.forEach(url => {

  //     this.myFormGroup.controls[url].disable();
  //     this.manageHideFields("hide", [url]);
  //     if (this.getTemplateInputtype(url) == "yesnotogglehideshow") {
  //       this.setSonsOfYesNoToggleHideShow(url)
  //     }
  //   });

  // }

  onOptionSelected(event) {
    let value = event;
    let selected = value;
    let kuku = this.myFormGroup.get("formControlName");
    // console.log("Chosen country: " + event.target.value);
    this.myFormGroup.get("");
    //   this.oppoSuitsForm.get('name').setValue(e.target.value, {
    //     onlySelf: true
    //  })
    //this.myFormGroup.value["itemName"]
    //console.log(value);
  }

  //see https://www.positronx.io/angular-7-select-dropdown-examples-with-reactive-forms/
  // changeItem(e, itemName: string) {
  //   this.myFormGroup.controls[itemName].setValue(e.target.value, {
  //     onlySelf: true
  //   })
  // }

  async checkPermissionsModal() {
    this.contributorArrays = []; // Ensure the array is empty before populating it
    
    for (let i = 0; i < this.myFormTemplate.fields.length; i++) {
      let localValue = await this.myFormGroup.controls[
        this.myFormTemplate.fields[i].fieldid
      ].value;
      console.log("localValue - ", localValue);
  
      this.contributorArrays.push(localValue);
    }
  
    // Check if any of the specific values are in the array
    if (this.contributorArrays.some(value => ["now", "future", "never"].includes(value))) {
      this.allThePermissionsAreContributor = false;
      console.log('false ', this.contributorArrays)
    } else {
      this.allThePermissionsAreContributor = true;
      console.log('true ', this.contributorArrays)
    }
  }

  onSelectFocus(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.previousValue = selectElement.value;
    console.log('Previous value:', this.previousValue);
  }

  async changeSelection(event: Event, urlsParams, alreadySelected?) {   
    // const selectElement = event.target as HTMLSelectElement;
    // const selectedValue = selectElement.value;
    // console.log('Selected value:', selectedValue);
    this.checkPermissionsModal();
    

    console.log("urlsParams", urlsParams);
    //in dynamic-edit, "url" means the name fo the field we want to show/hide
    var selected;
    var chosenUrlParameter;
    if (alreadySelected) {
      selected = alreadySelected;
    } else {
      // selected = event.target.value;
    }
    //get the urlParameter for the slected item
    chosenUrlParameter = urlsParams.find(
      (element) => element.option === selected
    );

    urlsParams.forEach((param) => {
      if (param.urlArray) {
        param.urlArray.forEach((element2) => {
          if ((chosenUrlParameter.urlArray as [""]).includes(element2)) {
            if (this.myFormGroup.controls[element2]) {
              this.myFormGroup.controls[element2].enable();
              this.manageHideFields("show", [element2]);
            }
          } else {
            if (this.myFormGroup.controls[element2]) {
              this.myFormGroup.controls[element2].disable();
              this.manageHideFields("hide", [element2]);
            }
            // the field will be disabled and not submitted, so we don't need to reset the content. this.myFormGroup.controls[element.url].setValue("");
          }
        });
      } //simple enable or disable one field per radio click
      else {
      }
    });
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key); //this.myTextList.find(kk=>kk.key==key).value;
    return txt;
  }

  async goto(url?: string) {
    let myUser = await this.ZpDataService.getItemUser(this.Id, "users");
    console.log("goto(), myUser - ", myUser);
    let refCodeInfo = await this.ZpDataService.getRefCode();
    if (myUser.length) {
      myUser = myUser[0];
      console.log("no delegates");
    }
    this.mySharedPlans = await this.ZpDataService.getMySharedPlans(
      myUser["Id"]
    );
    this.hasPlan = await this.ZpDataService.getPlan(myUser["Id"]);
    if (this.myFormTemplate.editInSteps) {
      this.submitted = false;
      console.log("no delegates");
    }
    if (url === 'saveDelegatePermissions') {
      console.log("delegates permissions");
      this.onSubmit();
      this.router.navigate(["/dynamicgrid/delegates-grid"]);
    }
    if (this.myFormGroup.valid) {
      console.log("goto(), myFormGroup values - ", this.myFormGroup.value);
      console.log("no delegates");
      if (
        !this.mySharedPlans ||
        this.mySharedPlans.length == 0 ||
        this.hasPlan ||
        this.myUser.userType != undefined
      ) {
        if (this.myFormTemplate.subject == "Tell us a bit about you") {
          console.log("no delegates");
          this.goAuthenticate(this.myFormGroup.value);
        }
        if (
          this.myFormTemplate.finishedbuttontext == "Save Changes" ||
          this.myFormTemplate.finishedbuttontext == "saves changes"
        ) {
          const previousUrl = this.myFormTemplate.url;
          switch (previousUrl) {
            case "my-assets":
              console.log("no delegates");
              this.router.navigate(["/my-assets"]);
              break;
            case "my-debts":
              console.log("no delegates");
              this.router.navigate(["/my-debts"]);
              break;
            case "my-daily-life":
              console.log("no delegates");
              this.router.navigate(["/my-daily-life"]);
              break;
            case "my-digital-life":
              console.log("no delegates");
              this.router.navigate(["/my-digital-life"]);
              break;
            case "my-wishes":
              console.log("no delegates");
              this.router.navigate(["/my-wishes"]);
              break;
            case "delegates":
              console.log("delegates");
              this.router.navigate(["/dynamicgrid/delegates-grid"]);
          }
        } else {
          if (myUser.userType == "professional") {
            console.log("no delegates");
            this.goAuthenticate(this.myFormGroup.value);
          }
          if (myUser.userType == "professionalManager") {
            console.log("no delegates");
            this.goAuthenticate(this.myFormGroup.value);
          }
        }
      } else {
        if (this.myFormTemplate.subject == "Tell us a bit about you") {
          console.log("no delegates");
          this.goAuthenticate(this.myFormGroup.value, "delegate");
        } else {
          // Don't think that the code reaches here
          console.log("no delegates");
          this.router.navigate(["/delegate-home-page"]);
          this.sideNavBarVisibilityService.changeMessage("top");
        }
      }
    }
  }

  goAuthenticate(formGroupValues, user?) {
    this.getInfoAndPassService.getInfoAndPass(formGroupValues, user);
    this.router.navigate(["/auth"]);
  }

  backto() {
    let urlBack = this.myFormTemplate.urlBack;
    if (!urlBack) {
      urlBack = this.myFormTemplate.url;
      urlBack = urlBack.replace(/s$/, "") + "-view";
    }
    this.router.navigate(["/" + urlBack + "/" + this.Id]);
    // const referrer = this.previousUrlService.getPreviousUrl();
    // this.router.navigate([referrer])
  }

  public MatchConfirmed(e, controls: string[]) {
    if (!this.myFormGroup.controls[controls[0]]) {
      return;
    }
    if (!this.myFormGroup.controls[controls[1]]) {
      return;
    }
    let value1 = this.myFormGroup.controls[controls[0]];
    let value2 = this.myFormGroup.controls[controls[1]];
    if (value1.value === value2.value) {
      value2.setErrors(null);
    } else {
      value2.setErrors({ notEquivalent: true });
    }
  }

  toggleStatus(explanation: any): void {
    explanation.status = !explanation.status;
  }

  private emailValidator(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      if (!group.controls["email"]) {
        return;
      }
      if (!group.controls["emailConfirm"]) {
        return;
      }
      const email = group.controls["email"];
      const confirmEmail = group.controls["confirmEmail"];
      if (email.value !== confirmEmail.value) {
        confirmEmail.setErrors({ notEquivalent: true });
      } else {
        confirmEmail.setErrors(null);
      }
      return;
    };
  }

  // async addInsuranceToProperty(insuranceId,propertyId,clientId){
  //   //when a user adds a property to an insruance, we will add the isnurance to the property
  //   //Check if the insurance is already connected to the property
  //   let myProperty = await this.ZpDataService.getItem(propertyId, "property", clientId);
  //   if(!myProperty["propertyInsurances"] || !myProperty["propertyInsurances"].includes(insuranceId)){
  //     if(!myProperty["propertyInsurances"]){
  //       myProperty["propertyInsurances"] = [];
  //       myProperty["propertyHasInsurances"] = true;
  //     }
  //     myProperty["propertyInsurances"].push(insuranceId);
  //     this.ZpDataService.updateItem(myProperty,"property");
  //     return true;
  //   }
  //   return false;
  // }
  checkOnKeyUp() {
    console.log("checkOnKeyUp()");
  }
  addNewItem() {
    console.log("addNewItem()");
  }

  handlePersonData(event?: any) {
    console.log("handlePersonData()");
  }

  toggleExplanations($event: any) {
    $event.stopPropagation();
    this.statusExplanations = !this.statusExplanations;
  }

  ngOnDestroy() {
    if (this.subscription) {
      //this.subscription.unsubscribe();
    }
    this.sideNavBarVisibilityService.hideSideNav = false;
  }

  //see https://www.positronx.io/angular-7-select-dropdown-examples-with-reactive-forms/
  changeItem(e, itemName: string) {
    this.myFormGroup.controls[itemName].setValue(e.target.value, {
      onlySelf: true,
    });
  }
}
